import appConfig from '@frontend/env';
import { http } from '@frontend/fetch';
import { JustifiPublicCheckoutBody, JustifiPublicCheckoutProps, JustifiPublicCheckoutResponse } from './types';

const { PAY_BACKEND_API } = appConfig;
const LOCATION_ID_HEADER = 'Location-Id';

export const justifiPublicCheckout = ({
  checkoutId,
  locationId,
  paymentMethodId,
  idempotentId,
}: JustifiPublicCheckoutProps) =>
  http.post<JustifiPublicCheckoutResponse, JustifiPublicCheckoutBody>(
    `${PAY_BACKEND_API}/payments/justifi/checkout/${checkoutId}/complete:proxy`,
    { locationId, paymentMethodId, idempotentId },
    { skipValidation: true, headers: { [LOCATION_ID_HEADER]: locationId } }
  );
